module.exports = __webpack_public_path__ + "static/media/Mask Group 8@2x.98d83160.png";